import { useEffect, useState } from 'react';

import { isInterviewPast } from '@/utils/interview';

const MAX_TIMER_DELAY = 2_147_483_647;

const useInterviewStarted = (startsAt: string | null): boolean => {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!startsAt) {
      return undefined;
    }

    let timerID: number | undefined;

    const onTimer = () => {
      const delay = new Date(startsAt).getTime() - Date.now();

      if (delay <= 0) {
        setTick(tick => tick + 1);

        return;
      }

      timerID = window.setTimeout(onTimer, Math.min(delay, MAX_TIMER_DELAY));
    };

    onTimer();

    return () => {
      window.clearTimeout(timerID);
    };
  }, [startsAt]);

  return isInterviewPast(startsAt);
};

export {
  useInterviewStarted,
};
